import { ConfigureProps } from 'react-instantsearch';

export type ConfigProps = Omit<ConfigureProps, 'hitsPerPage'>;

export const ALL_SECTION_INDEX = 9999; // something high and out of range
